import {
  HttpClient, HttpEvent, HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject, Observable, Subject,
} from 'rxjs';

import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class EntityService {
  private _entityData$ = new BehaviorSubject<any>(null);
  public readonly entityData$ = this._entityData$.asObservable();

  private _reloadLogo$ = new Subject<void>();
  public readonly reloadLogo$ = this._reloadLogo$.asObservable();

  user: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toast: ToastService,
  ) {
    this.authService.user$.subscribe((user: any) => this.user = user)
  }

  triggerLogoReload() {
    this._reloadLogo$.next();
  }

  getEntity = (includedAssociations: any) => {
    return this.http.get(`${environment.expressUrl}/entities`,
      {
        headers: { 'Content-Type': 'application/vnd.api+json' },
        params: { 'loginName': this.user.loginName, includedAssociations: includedAssociations },
      })
      .subscribe({
        next: (response: any) => {
          this._entityData$.next(response.data);
        },
        error: (error) => {
          console.log('error', error);
        },
      })
  }

  getEntityLogo(loginName: string): Observable<any> {
    return this.http.get(`${environment.expressUrl}/entities/logo`,
      {
        headers: { 'Content-Type': 'application/vnd.api+json' },
        params: { loginName },
      });
  }

  updateEntity = (entityData: any) => {

    const body = {
      loginName: this.user.loginName,
      ...entityData,
    }

    return this.http.put(
      `${environment.expressUrl}/entities`,
      body,
      { headers: { 'Content-Type': 'application/vnd.api+json' } },
    )
      .subscribe({
        next: (response: any) => {
          this._entityData$.next(response.data.current);

          this.toast.setToast({
            text: 'Entity updated',
            type: 'success',
            icon: true,
            dismissible: true,
          })
        },
        error: (error) => {
          console.log('error', error);
          this.toast.setToast({
            text: 'Error updating entity',
            type: 'error',
            icon: true,
            dismissible: true,
          })
        },
      })
  }

  generateSignedUrl = (
    fileName: string, mimeType: string, fileType: string, courseItemId?: number,
  ) => {
    return this.http.post(
      `${environment.expressUrl}/utils/get-signed-url`,
      {
        loginName: this.user.loginName,
        fileName,
        mimeType,
        fileType,
        courseItemId,
      },
      { headers: { 'Content-Type': 'application/vnd.api+json' } },
    );
  }

  uploadSignedUrl(url: string, blobData: Blob): Observable<HttpEvent<any>> {
    return this.http.put(
      url, blobData, {
        reportProgress: true,
        observe: 'events',
        headers: new HttpHeaders({ 'Content-Type': blobData.type }),
        responseType: 'text',
      },
    );
  }

  getImageFromSignedUrl(signedUrl: string): Observable<Blob> {
    return this.http.get(signedUrl, { responseType: 'blob' });
  }

  setEntityLogo(
    loginName: string, filePath: string, fileName: string,
  ): Observable<any> {
    const body = {
      loginName, filePath, fileName,
    };
    return this.http.post(
      `${environment.expressUrl}/entities/logo`,
      body,
      { headers: { 'Content-Type': 'application/vnd.api+json' } },
    );
  }

  getEntityDataValue(): any {
    return this._entityData$.value;
  }

  removeEntityLogo(loginName: string): Observable<any> {
    const body = { loginName };

    return this.http.delete(`${environment.expressUrl}/entities/logo`,
      {
        headers: { 'Content-Type': 'application/vnd.api+json' },
        body,
      });
  }

}
